import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse, TUserAccount } from "types";

import { getUserInfoService } from "../api";

export const useGetUserAccountsQuery = (userId: string): UseQueryResult<TUserAccount[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.get_user_accounts, userId],
    queryFn: () => getUserInfoService(userId),
    enabled: Boolean(userId),
    onError: (error: ErrorResponse) => errorModal(error),
    useErrorBoundary: true,
    select: res => res.data.accounts
  });
